import React from "react";

export const MENTION_ENTITY = "MENTION";

export function mentionEntityStrategy(contentBlock, callback, contentState) {
  contentBlock.findEntityRanges((character) => {
    const entityKey = character.getEntity();
    return (
      entityKey !== null &&
      contentState.getEntity(entityKey).getType() === MENTION_ENTITY
    );
  }, callback);
}

/** Draft.js decorator; styles from `.comment-mention` in `style.css`. */
export function MentionSpan({ children }) {
  return <span className="comment-mention">{children}</span>;
}
